import React from 'react';
import { AwardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-background py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-120" data-mp="1j9qpghfdfsh6">
      <div className="mx-auto max-w-3xl px-4" data-id="element-121" data-mp="1na0r5hw4rwq8">
        <SectionHeading id="pricing-title" data-id="element-122" data-mp="1s9dh4biatjx1">Choose Your Option</SectionHeading>

        <article className="mt-10 overflow-hidden rounded-3xl border-2 border-cta bg-surface shadow-2xl shadow-black/50" data-id="element-123" data-mp="1sbgh9od60tfh">
          <div className="border-b border-primary/30 bg-background/50 px-6 py-4 sm:px-10" data-id="element-124" data-mp="227jjeu80os2f">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary bg-primary/15 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-foreground" data-id="element-125" data-mp="2uytxvmxi53n">
              <AwardIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-126" data-mp="1mgoelaxrp9kc" /> Main Offer
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-127" data-mp="1hpogi2cwwlg9">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-128" data-mp="1hon702bjo70n">
              <div data-id="element-129" data-mp="1cr4vc4657doy">
                <h3 className="text-3xl font-bold leading-tight tracking-tight text-foreground" data-id="element-130" data-mp="1coim803lsq4m">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-131" data-mp="25faeimhjsumo">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-132" data-mp="20emr0asj2vx7">
                <span className="text-sm text-muted" data-id="element-133" data-mp="1vgbj45lsmvhm">
                  Regular price: <span className="line-through decoration-primary decoration-2" data-id="element-134" data-mp="1rg198huvrkxh">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-primary" data-id="element-135" data-mp="k38zt2sb7rtr">Today:</p>
                <p className="mt-1 whitespace-nowrap text-6xl font-bold leading-none tracking-tight text-accent" data-id="element-136" data-mp="fzjcegndfgab">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-137" data-mp="mguqvxzn03lm">
              Get my professional edition now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-138" data-mp="7ly8iry45zut">
              <span className="inline-flex items-center gap-1.5" data-id="element-139" data-mp="3uwo5u8ebl70k">
                <LockIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-140" data-mp="3uvd38bwm25b1" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-141" data-mp="3jth7zv51fbc">
                <ZapIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-142" data-mp="3kztatzh99or1" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="3pxur6cnar9yt">
                <ShieldCheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-144" data-mp="3byv1r2rymr1l" /> 7-day guarantee
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}